<script lang="ts">
  import Weather from "./componets/Weather.svelte";
</script>

<main class="text-center ">
  <h2 class="display-1">Weather App!</h2>
  <hr />
  <Weather />
</main>

<style>
</style>
